
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M15.1 19.37L16.1 21.11C15.14 21.55 14.09 21.84 13 21.95V19.93C13.74 19.84 14.44 19.65 15.1 19.37ZM4.06999 13H2.04999C2.15999 14.1 2.44999 15.14 2.88999 16.1L4.62999 15.1C4.34999 14.44 4.15999 13.74 4.06999 13ZM15.1 4.62999L16.1 2.88999C15.14 2.44999 14.1 2.15999 13 2.04999V4.06999C13.74 4.15999 14.44 4.34999 15.1 4.62999ZM19.93 11H21.95C21.84 9.89999 21.55 8.85999 21.11 7.89999L19.37 8.89999C19.65 9.55999 19.84 10.26 19.93 11ZM8.89999 19.37L7.89999 21.11C8.85999 21.55 9.90999 21.84 11 21.95V19.93C10.26 19.84 9.55999 19.65 8.89999 19.37ZM11 4.06999V2.04999C9.89999 2.15999 8.85999 2.44999 7.89999 2.88999L8.89999 4.62999C9.55999 4.34999 10.26 4.15999 11 4.06999ZM18.36 7.16999L20.1 6.15999C19.47 5.28999 18.7 4.51999 17.83 3.88999L16.82 5.62999C17.41 6.07999 17.92 6.58999 18.36 7.16999ZM4.62999 8.89999L2.88999 7.89999C2.44999 8.85999 2.15999 9.89999 2.04999 11H4.06999C4.15999 10.26 4.34999 9.55999 4.62999 8.89999ZM19.93 13C19.84 13.74 19.65 14.44 19.37 15.1L21.11 16.1C21.55 15.14 21.84 14.09 21.95 13H19.93ZM16.83 18.36L17.84 20.1C18.71 19.47 19.48 18.7 20.11 17.83L18.37 16.82C17.92 17.41 17.41 17.92 16.83 18.36ZM7.16999 5.63999L6.16999 3.88999C5.28999 4.52999 4.52999 5.28999 3.89999 6.16999L5.63999 7.17999C6.07999 6.58999 6.58999 6.07999 7.16999 5.63999ZM5.63999 16.83L3.89999 17.83C4.52999 18.7 5.29999 19.47 6.16999 20.1L7.17999 18.36C6.58999 17.92 6.07999 17.41 5.63999 16.83ZM12 6.99999C11.45 6.99999 11 7.44999 11 7.99999V11.59C11 12.12 11.21 12.63 11.59 13L14.59 16C14.98 16.39 15.61 16.39 16 16C16.39 15.61 16.39 14.98 16 14.59L13 11.59V7.99999C13 7.44999 12.55 6.99999 12 6.99999Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-history-toggle-off`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconHistoryToggleOff

    ```js
    <b-new-b-icon-history-toggle-off />
    ```
</docs>


